const LinkTypeField = ({ item, forTable, rowsItem }) => {
  if (forTable && (item.name == 'sources_count' || item.name == 'samples_count')) {
    return (
      <div
        style={
          rowsItem.value[item.name]
            ? {
                display: 'inline-block',
                cursor: 'pointer',
                textDecoration: 'underline',
                color: 'blue',
              }
            : undefined
        }
      >
        {' '}
        {rowsItem.value[item.name]}{' '}
      </div>
    );
  }
  return null;
};

export default LinkTypeField;
